import { getPortalId } from '../../../utils/getPortalId';
import { StopPingError } from './StopPingError';
import { setStorageJsonValue, SUPERSTORE_NAMESPACES, SUPERSTORE_STORAGE_ITEMS, SUPERSTORE_STORAGE_KEYS } from '../../../utils/superStoreUtils';
import { debug } from '../../../utils/DebugUtil';
import { isResponse } from '../../../utils/isResponse';
import { apiClientWithMiddleware } from '../../../api/utils';
export const renewPresenceToken = async () => {
  try {
    const response = await apiClientWithMiddleware().putWithResponse(`/presence/v1/presence?portalId=${getPortalId()}`);
    await setStorageJsonValue({
      namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
      storageKey: SUPERSTORE_STORAGE_KEYS.BROWSER,
      storageItem: SUPERSTORE_STORAGE_ITEMS.PRESENCE_PING_TOKEN,
      value: response.data
    });
    debug('renewed presence token');
    return response.data;
  } catch (e) {
    // Stop pinging the service the user gets back a 401 or 403 as this means
    // that either their login has expired (401) or it could be a jita user
    // with their permissions expiring, or a regular user getting removed
    // from a portal etc. (403)
    // https://hubspot.slack.com/archives/C2AR97NDV/p1574274291309800?thread_ts=1574006542.268100&cid=C2AR97NDV
    if (isResponse(e)) {
      if ([401, 403].includes(e.status)) {
        throw new StopPingError('user cannot get presence token, should not retry');
      }
    }
    debug('presence token failed to renew', e);
    throw e;
  }
};